import {cylinder_pos, freepanelpos, icons, last_symbol, symbols} from "./stars_config";
import {
    behavior_config,
    states,
    server_result,
    fps,
    ico_he,
    picture_convert,
    reels_lenghts,
    reels_pos,
    rotated,
    round_running,
    server_config,
    set_forcestopnow,
    set_rotated,
    forcestopnow,
    set_inanim,
    set_inwincount,
    big_win,
    wi,
    he,
    mega_win,
    super_win, set_inbigwin, inmoneyadd, inbigwin, set_inmoneyadd
} from "../framework/src/engine/madnes/madnes_variables";
import {
    bet,
    madnes_add_win,
    madnes_end_round,
    madnes_get_currtime, madnes_is_in_autostart,
    madnes_money_to_coin,
    madnes_new_round, madnes_reels_start, madnes_reels_stop,
    madnes_win_anim_reset, madnes_win_anim_skip, win
} from "../framework/src/engine/madnes/madnes";
import {
    madnes_get_pos_x,
    madnes_get_pos_y,
    madnes_get_scale_y,
    madnes_get_texture,
    madnes_key_exist,
    madnes_set_alpha, madnes_set_angle,
    madnes_set_img_center,
    madnes_set_pos,
    madnes_set_pos_y,
    madnes_set_scale,
    madnes_set_texture
} from "../framework/src/engine/madnes/madnes_object";
import {
    madnes_anim_add,
    madnes_anim_is_playing,
    madnes_anim_play,
    madnes_show_money, madnes_start_coin, madnes_stop_coin
} from "../framework/src/engine/madnes/madnes_anims";
import {
    madnes_audio_loop,
    madnes_audio_pause,
    madnes_audio_play,
    madnes_audio_stop
} from "../framework/src/engine/madnes/madnes_audio";
import {
    madnes_add_to_render,
    madnes_alpha_to,
    madnes_move_to,
    madnes_rem_from_render
} from "../framework/src/engine/madnes/madnes_render";
import {result_lock, stars_print_reels} from "./stars_core_printer";
import {stars_result_control_mystery_1} from "./stars_anims";
import {madnes_add_bitmap_text, madnes_set_text} from "../framework/src/engine/madnes/madnes_text";
import {STATES} from "../framework/src/states/states";

var rotate_start_time = 0;
var rotate_start_pos = [];
var rotate_start_in_accel = 0;
var rotate_start_swing = 0;
var can_stop = 0;
var rotate_control_start_time = 0;
var rotate_control_swing_end = 0;

var in_free_spins = false;
var in_free_spins_pos = 0;
var in_free_spins_total = 0;

var autospin_force = false;
var autospin_force_enabled = false;

export function stars_rotate_run()
{
    if(round_running) //waiting for end round
    {
        return;
    }

    stars_rotate_start();
}

var stars_rotate_control_start_sym;
var autostart;
var force_res;

function stars_rotate_start()
{
    if(rotated == 0)
    {
        // madnes_on_round_start();
        //
        // madnes_show_stop();

        madnes_win_anim_reset();

        for(var i in server_config.logic.reels)
        {
            while(stopposin[i] > server_config.logic.reels[i].length)
            {
                stopposin[i] = stopposin[i] * 1 - server_config.logic.reels[i].length;
                stopposin_old[i] = stopposin[i];
                reels_pos[i] = stopposin[i] * ico_he;
            }
        }

        if(autostart != "∞" && autostart*1 > 0 && !in_free_spins)
        {
            autostart = autostart*1-1;
        }
        set_rotated(1);

        madnes_audio_play("pre_reels")

        startposin = JSON.parse(JSON.stringify(stopposin));

        if(!in_free_spins)
        {
            // madnes_new_round();
            force_res = "";
        }

        for(var i = 0; i < cylinder_pos.length; i++)
        {
            symbols[i] = 0;
            last_symbol[i] = -1;
            rotate_start_pos[i] = reels_pos[i];
        }

        // if(!in_free_spins)
        // {
        // 	/*
        // 	stars_freespin_hide(1);
        // 	stars_freespin_hide(2);
        // 	stars_freespin_hide(3);
        // 	stars_freespin_hide(4);
        // 	stars_freespin_hide(5);
        // 	*/
        // }

        can_stop = 0;

        rotate_start_time = madnes_get_currtime();

        rotate_control_start_time = 0;
        rotate_start_in_accel = 0;
        rotate_start_swing = 0;
        set_forcestopnow(0);
        scatters_runned = false;

        madnes_audio_play("REEL_START");

        madnes_add_to_render(stars_rotate_start);
        madnes_reels_start();
    }
    else
    {
        var time = madnes_get_currtime() - rotate_start_time;

        if(
            rotate_start_swing < behavior_config.reel.acceleration.swingCount &&

            time < behavior_config.reel.acceleration.moveBackTime * 1000 &&
            rotate_start_in_accel == 0
        )
        {
            // back
            var time_perc = ( ( 100 / ( behavior_config.reel.acceleration.moveBackTime * 1000 ) ) * time ) / 100;
            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] - ( behavior_config.reel.acceleration.accelerationHeight * ico_he * time_perc );
            }
        }
        else if(
            rotate_start_swing < behavior_config.reel.acceleration.swingCount &&

            time < behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000 &&
            rotate_start_in_accel == 0
        )
        {
            // keep
            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] - ( behavior_config.reel.acceleration.accelerationHeight * ico_he);
            }
        }
        else if(
            rotate_start_swing < behavior_config.reel.acceleration.swingCount &&

            //time < behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000 + behavior_config.reel.acceleration.moveTime * 1000 &&
            time < behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000 + behavior_config.reel.acceleration.moveBackTime * 1000 &&
            rotate_start_in_accel == 0
        )
        {
            // acc

            var time_perc =
                1 - (
                    (
                        (
                            100 / (
                                //behavior_config.reel.acceleration.moveTime * 1000
                                behavior_config.reel.acceleration.moveBackTime * 1000
                            )
                        ) * (
                            time - (
                                behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000
                            )
                        )
                    ) / 100
                );

            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] - ( behavior_config.reel.acceleration.accelerationHeight * ico_he * time_perc );
            }

        }
        else if(
            rotate_start_in_accel == 0
        )
        {
            // rotate accel start or repeat

            madnes_audio_loop("reels");

            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i];
            }

            rotate_start_time = madnes_get_currtime();

            if(++rotate_start_swing >= behavior_config.reel.acceleration.swingCount)
            {

                for(var i = 0; i < cylinder_pos.length; i++)
                {
                    if(behavior_config.reel.spin.motionBlur == 1)
                    {
                        madnes_anim_play("reels_bufer_" + i + "_S0", "blur");
                        madnes_anim_play("reels_bufer_" + i + "_S1", "blur");
                        madnes_anim_play("reels_bufer_" + i + "_S2", "blur");

                        for(var j = 0; j < reels_lenghts[i]; j++)
                        {
                            madnes_anim_play("reels_bufer_" + i + "_" + j, "blur");
                        }

                    }
                }

                rotate_start_in_accel = 1;

                stars_rotate_control_start_sym = Math.round(rotate_start_pos[0] / ico_he);
                rotate_control_start_time = madnes_get_currtime();
            }
        }
        else if(
            rotate_start_in_accel == 1
        )
        {
            // accel start
            var start_speed = behavior_config.reel.acceleration.accelerationHeight / behavior_config.reel.acceleration.moveBackTime;

            if(!isFinite(start_speed) || isNaN(start_speed))
            {
                start_speed = 0;
            }

            var end_speed = behavior_config.reel.spin.commonSpeed;
            if(in_free_spins)
            {
                end_speed = behavior_config.reel.spin.freeSpinSpeed;
            }

            var end_time = behavior_config.reel.spin.timeToReachFullSpeed * 1000;

            var perc = 0;
            var speed = 0;
            var pos = 0;
            var sampling = 10;

            for(var i = 0; i <= time; i = i + sampling)
            {
                perc = 100 / end_time * i;
                if(!isFinite(perc) || isNaN(perc))
                {
                    perc = 0;
                }
                speed = ( ( end_speed - start_speed ) * ( perc / 100 ) ) + start_speed;
                pos = pos + ( speed / ( 1000 / ( sampling ) ) );
            }

            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] + pos * ico_he;
            }

            if(
                !(
                    time < behavior_config.reel.spin.timeToReachFullSpeed * 1000
                )
            )
            {
                pos = 0;

                for(var i = 0; i <= ( behavior_config.reel.spin.timeToReachFullSpeed * 1000 ); i = i + sampling)
                {
                    perc = 100 / end_time * i;
                    if(!isFinite(perc) || isNaN(perc))
                    {
                        perc = 0;
                    }
                    speed = ( ( end_speed - start_speed ) * ( perc / 100 ) ) + start_speed;
                    pos = pos * 1 + ( speed / ( 1000 / ( sampling ) ) );
                }

                rotate_control_swing_end = pos;

                madnes_rem_from_render(stars_rotate_start);
                madnes_add_to_render(stars_rotate_control);
            }
        }

        stars_print_reels();
    }
}

// Kontrola probihajici rotace valcu
var alldone = new Array();

export var stopposin = new Array();
var startposin = new Array();

var stopposin_round = new Array();
var stopping = new Array();

export var stopposin_old = new Array();
var stoppostime_br = new Array();
var stoppostime = new Array();

var stoppos_swing = new Array();

var scatters = 0;
var saloons = 0;
var all_set_for_stop = 0;

var scatters_runned = false;
function stars_rotate_control()
{
    var time = madnes_get_currtime();

    if(rotated == 1 || all_set_for_stop == 0)
    {
        // Toci se a zatim se neceka ukonceni

        for(var i = 0; i < cylinder_pos.length; i++)
        {
            if(server_result != null && result_lock == 0)
            {
                stopposin[i] = -1;
                stopposin_round[i] = 0;
                stopping[i] = 0;
                stoppostime_br[i] = -1;
                stoppos_swing[i] = 0;
                stoppostime[i] = -1;
                can_stop = 1;
            }

            alldone[i] = 0;

            var cs = behavior_config.reel.spin.commonSpeed;
            if(in_free_spins)
            {
                cs = behavior_config.reel.spin.freeSpinSpeed;
            }

            reels_pos[i] =
                (
                    rotate_start_pos[i] +
                    (
                        (
                            (
                                (
                                    time - rotate_control_start_time - (
                                        behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                    )
                                ) / 1000
                            ) * cs
                        ) + rotate_control_swing_end
                    ) * ico_he
                );
            var symbdiff =
                (
                    (
                        (
                            (
                                time - rotate_control_start_time - (
                                    behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                )
                            ) / 1000
                        ) * cs
                    ) + rotate_control_swing_end
                );
        }

        scatters = 0;
        saloons = 0;

    }
    else
    {
        // Je na case ukoncit toceni na spravnych pozicich

        for(var i = 0; i < cylinder_pos.length; i++)
        {
            if(stopposin[i] == -1)
            {
                // Nejsou nastaveny pozice pro ukonceni -> nastavuji
                if(forcestopnow == 1)
                {
                    var cs = behavior_config.reel.spin.commonSpeed;
                    if(in_free_spins)
                    {
                        cs = behavior_config.reel.spin.freeSpinSpeed;
                    }

                    var strns = cs * behavior_config.reel.spin.timeToReachNullSpeed;

                    stopposin[i] = Math.round(reels_pos[i] / ico_he) + ( 2 + /* 3 + Math.floor( cs / 4 ) +*/ Math.ceil( strns ) );

                    if(i > 0)
                    {
                        stopposin[i] = ( reels_lenghts[0] - startposin[0] ) + ( ( stopposin_round[0] - 1 ) * reels_lenghts[0] ) + stopposin[0] + startposin[i];
                    }

                }
                else
                {
                    var del = 1;
                    if(typeof behavior_config.reel.spin.delayBetweenReelStops != "undefined")
                    {
                        del = behavior_config.reel.spin.delayBetweenReelStops;
                    }
                    var cs = behavior_config.reel.spin.commonSpeed;
                    if(in_free_spins)
                    {
                        cs = behavior_config.reel.spin.freeSpinSpeed;
                    }

                    var strns = cs * behavior_config.reel.spin.timeToReachNullSpeed;

                    stopposin[i] = Math.round(reels_pos[i] / ico_he) + /*(i * del) + */( 2 + /* 3 + Math.floor( cs / 4 ) +*/ Math.ceil( strns ) );

                    if(i > 0)
                    {
                        stopposin[i] = ( reels_lenghts[0] - startposin[0] ) + ( ( stopposin_round[0] - 1 ) * reels_lenghts[0] ) + stopposin[0] + startposin[i] + ( i * del );
                    }
                }

                if(i == 2)
                {
                    var myst = 0;

                    for(var j = 0; j < i; j++)
                    {
                        for(var spos = 0; spos <= 2; spos++)
                        {
                            if(server_result.result.reelMatrix[0][j][spos] == 10)
                            {
                                myst++;
                                spos = 10;
                            }
                        }
                    }

                    if(myst == 2)
                    {
                        if(typeof behavior_config.reel.spin.scatterDuration != "undefined")
                        {
                            var tmp_dur = behavior_config.reel.spin.scatterDuration * 1;
                            stopposin[i] += tmp_dur * 1;
                        }
                        else
                        {
                            stopposin[i] += 20;
                        }
                    }

                }

                /*
                var sc_tmp = 0;
                var sa_tmp = 0;

                var add_tmp_sc = 0;
                var add_tmp_sa = 0;

                for(var j = 0; j < i; j++)
                {
                    for(var spos = 0; spos <= 2; spos++)
                    {
                        if(server_result.result.reelMatrix[0][j][spos] == 8)
                        {
                            sa_tmp++;
                        }
                        else if(server_result.result.reelMatrix[0][j][spos] == 9)
                        {
                            sc_tmp++
                        }
                    }
                    if(sa_tmp >= 2)
                    {
                        add_tmp_sa++;
                    }
                    if(sc_tmp >= 2)
                    {
                        add_tmp_sc++;
                    }
                }

                if(sa_tmp >= 2 || sc_tmp >= 2)
                {
                    if(typeof behavior_config.reel.spin.scatterDuration != "undefined")
                    {
                        var add = add_tmp_sc;
                        if(add_tmp_sa > add)
                        {
                            add = add_tmp_sa;
                        }
                        add = add - 1;
                        var tmp_dur = behavior_config.reel.spin.scatterDuration * 1 + behavior_config.reel.spin.scatterDelay * add;
                        stopposin[i] += tmp_dur * 1;
                    }
                    else
                    {
                        stopposin[i] += 20;
                    }
                }
                */

                while(stopposin[i] <= 0)
                {
                    stopposin[i] = ( reels_lenghts[i] * 1 ) - stopposin[i];
                }

                stopposin_old[i] = stopposin[i];
            }

            var cs = behavior_config.reel.spin.commonSpeed;
            if(in_free_spins)
            {
                cs = behavior_config.reel.spin.freeSpinSpeed;
            }
            var end_break_reel_dist = madnes_get_end_dist();

            //var ttrfs = behavior_config.reel.spin.timeToReachFullSpeed;
            var ttrns = behavior_config.reel.spin.timeToReachNullSpeed;

            if(forcestopnow == 1)
            {
                end_break_reel_dist = 0;
                ttrns = 0.01;
            }

            var symbdiff =
                (
                    (
                        (
                            (
                                time - rotate_control_start_time - (
                                    behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                )
                            ) / 1000
                        ) * cs
                    ) + rotate_control_swing_end
                );

            if(
                forcestopnow == 0 &&
                (
                    (stopposin[i]) - end_break_reel_dist + 0 - ( rotate_start_pos[i] / ico_he ) >= symbdiff &&
                    (stopposin[i]) - end_break_reel_dist + 0 - ( rotate_start_pos[i] / ico_he ) >= 0
                )
            )
            {
                reels_pos[i] =
                    (
                        rotate_start_pos[i] +
                        (
                            (
                                (
                                    (
                                        time - rotate_control_start_time - (
                                            behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                        )
                                    ) / 1000
                                ) * cs
                            ) + rotate_control_swing_end
                        ) * ico_he
                    );

            }
            else if(stoppostime[i] == -1)
            {
                stopping[i] = 1;

                if(stoppostime_br[i] == -1)
                {
                    stoppostime_br[i] = time;
                }

                var dif_time = time - stoppostime_br[i];

                var cur_end = 0;

                if(dif_time <= ttrns * 1000)
                {
                    dif_time = madnes_get_dist_break(dif_time);

                    reels_pos[i] =
                        (
                            ( ( ( stopposin[i] + 0 ) - ( end_break_reel_dist * 1 ) + ( dif_time * 1 ) ) ) * ico_he

                        );
                }
                else
                {
                    cur_end = 1;
                }

                if(cur_end == 1)
                {
                    stoppostime[i] = time;

                    if(!in_free_spins)
                    {
                        //stars_freespin_hide(i + 1);
                    }

                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 ) * ico_he
                        );

                    if(alldone[i] == 0)
                    {
                        control_show_spin(i);
                        stars_control_stop_sound(i);

                        for(var spos = 0; spos <= 2; spos++)
                        {
                            /*if(server_result.result.reelMatrix[0][i][spos] == 8)
                            {
                                madnes_anim_play("reels_bufer_" + i + "_S" + ( 2 - spos ), "nowin")
                                saloons++;
                            }
                            else if(server_result.result.reelMatrix[0][i][spos] == 9)
                            {
                                // SCATTER
                                madnes_anim_play("reels_bufer_" + i + "_S" + ( 2 - spos ), "stop")
                                stars_scatter_scale_anim(i, 'S'+(2-spos), 0);
                                scatters++;
                            }
                            else
                            {*/
                            madnes_anim_play("reels_bufer_" + i + "_S" + ( 2 - spos ), "stop")
                            /*}

                            if(
                                (
                                    scatters == 2 ||
                                    saloons == 2
                                )
                                &&
                                scatters_runned == false &&
                                forcestopnow == 0 &&
                                i < 4
                            )
                            {
                                scatters_runned = true;
                                for(var ii = i+2; ii <= 5; ii++)
                                {
                                    if(forcestopnow == 0)
                                    {
                                        //stars_freespin_show(ii);
                                    }
                                }
                                madnes_audio_play("REEL_TEAS");
                            }*/
                        }

                        for(var j = 0; j < reels_lenghts[i]; j++)
                        {
                            madnes_anim_play("reels_bufer_" + i + "_" + j, "stop");
                        }

                        if(i == 1)
                        {
                            var myst = 0;

                            for(var j = 0; j < 2; j++)
                            {
                                for(var spos = 0; spos <= 2; spos++)
                                {
                                    if(server_result.result.reelMatrix[0][j][spos] == 10)
                                    {
                                        myst++;
                                        spos = 10;
                                    }
                                }
                            }

                            if(myst == 2)
                            {
                                madnes_audio_play("reel_Search");
                                madnes_alpha_to("bonus_bg_2", 1, 200);
                            }

                        }
                        else if(i == 2)
                        {
                            madnes_audio_stop("reel_Search");
                            madnes_alpha_to("bonus_bg_2", 0, 200);
                        }
                    }
                }
            }
            else
            {
                var end_time = stoppostime[i];
                var dif_time = time - end_time;

                var bh = behavior_config.reel.brake.brakeHeight;
                var kt = behavior_config.reel.brake.keepTime;
                var mbt = behavior_config.reel.brake.moveBackTime;
                //var mt = behavior_config.reel.brake.moveTime;
                var mt = behavior_config.reel.brake.moveBackTime;


                var cs = behavior_config.reel.spin.commonSpeed;
                if(in_free_spins)
                {
                    cs = behavior_config.reel.spin.freeSpinSpeed;
                }

                //cs - rychlost
                //bh - vyska
                mt = bh / cs;

                var swc = behavior_config.reel.brake.swingCount;

                if(dif_time < mt * 1000)
                {
                    var add_pos = ( ( (100 / ( mt * 1000 ) ) * dif_time ) / 100 ) * bh;

                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 + add_pos ) * ico_he
                        );
                }
                else if(dif_time < mt * 1000 + kt * 1000)
                {
                    if(i == reels_lenghts.length - 1)
                    {
                        madnes_audio_stop("reels");
                        madnes_audio_stop("REEL_TEAS");
                    }

                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 + bh ) * ico_he
                        );
                }
                else if(dif_time < mt * 1000 + kt * 1000 + mbt * 1000)
                {
                    if(i == reels_lenghts.length - 1)
                    {
                        madnes_audio_stop("reels");
                        madnes_audio_stop("REEL_TEAS");
                    }

                    var time2 = dif_time - ( mt * 1000 + kt * 1000 );

                    var add_pos = bh - ( ( ( (100 / ( mbt * 1000 ) ) * time2 ) / 100 ) * bh );

                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 + add_pos ) * ico_he
                        );

                }
                else
                {
                    if(i == reels_lenghts.length - 1)
                    {
                        madnes_audio_stop("reels");
                        madnes_audio_stop("REEL_TEAS");
                    }

                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0  ) * ico_he
                        );

                    if(++stoppos_swing[i] < swc)
                    {
                        stoppostime[i] = time;
                    }
                    else
                    {
                        alldone[i] = 1;
                    }
                }

            }
        }

        if(alldone.indexOf(0) == -1)
        {
            madnes_audio_stop("reels");
            madnes_audio_stop("REEL_TEAS");

            //madnes_hide_stop();

            setTimeout(stars_result_control, 100);
            madnes_rem_from_render(stars_rotate_control);
            madnes_reels_stop();
        }

    }

    stars_print_reels();
}

function control_show_spin(reel) {
    if(reel == 1 && !in_free_spins && !madnes_is_in_autostart())
    {
        states.setState(STATES.FORCESPIN);
        // autospin_force_enabled = true;
        // madnes_show_spin();
    }

}

var madnes_get_end_dist_tmp = -1;
var madnes_get_end_dist_tmp_free = -1;
function madnes_get_end_dist()
{
    if(in_free_spins)
    {
        if(madnes_get_end_dist_tmp_free != -1)
        {
            return madnes_get_end_dist_tmp_free;
        }
    }
    else
    {
        if(madnes_get_end_dist_tmp != -1)
        {
            return madnes_get_end_dist_tmp;
        }
    }

    var total_time = behavior_config.reel.spin.timeToReachNullSpeed * 1000;
    var distance = madnes_get_dist_break(total_time);

    if(in_free_spins)
    {
        madnes_get_end_dist_tmp_free = distance;
    }
    else
    {
        madnes_get_end_dist_tmp = distance;
    }

    return distance;
}

function madnes_get_dist_break(time)
{
    var sampling = 10;

    //var end_speed = behavior_config.reel.brake.brakeHeight / behavior_config.reel.brake.moveTime;
    var end_speed = behavior_config.reel.brake.brakeHeight / behavior_config.reel.brake.moveBackTime;

    if(!isFinite(end_speed) || isNaN(end_speed))
    {
        end_speed = 0;
    }

    var start_speed = behavior_config.reel.spin.commonSpeed;
    if(in_free_spins)
    {
        start_speed = behavior_config.reel.spin.freeSpinSpeed;
    }

    end_speed = start_speed;

    var total_time = behavior_config.reel.spin.timeToReachNullSpeed * 1000;

    var distance = 0;

    for(var i = 0; i <= time; i += sampling)
    {
        var proc = 100 - ( ( 100 / total_time ) * i );
        var speed = ( ( start_speed - end_speed ) * ( proc / 100 ) ) + end_speed;
        distance = ( distance * 1 ) + ( speed * sampling ) ;
    }
    distance = distance / 1000;
    return distance;
}

// Pozadavek na dotoceni valce
var stars_rotate_stop_loading = 0;
export function stars_rotate_stop()
{
    if(rotated != 0 && stars_rotate_stop_loading == 0)
    {
        for(var i = 0; i < cylinder_pos.length; i++)
        {
            stopposin_old[i] = -1;
        }
        all_set_for_stop = 0;
        stars_rotate_stop_loading = 1;
        var poss = 0;

        for(var i in server_result.result.reelMatrix[0])
        {
            for(var j in server_result.result.reelMatrix[0][i])
            {
                madnes_set_texture("reels_bufer_" + i + "_S" + ( 2 - j ), picture_convert[server_result.result.reelMatrix[0][i][j]] + "_blur");

                madnes_anim_add("reels_bufer_" + i + "_S" + ( 2 - j ), "stop", [1]);
                madnes_anim_add("reels_bufer_" + i + "_S" + ( 2 - j ), "blur", [0]);

                if(behavior_config.reel.spin.motionBlur == 1)
                {
                    madnes_anim_play("reels_bufer_" + i + "_S" + ( 2 - j ), "blur");
                }
                else
                {
                    madnes_anim_play("reels_bufer_" + i + "_S" + ( 2 - j ), "stop");
                }
            }
        }

        setTimeout(function() {

            all_set_for_stop = 1;
            stars_rotate_stop_loading = 0;

        }, (1000 / ( fps ) ) * poss);

        set_rotated(0);
    }
}

function stars_control_stop_sound(reel)
{
    madnes_audio_play("reel_stop_"+(reel+1));

    var up_sym = server_result.result.reelMatrix[0][reel][0];
    var mi_sym = server_result.result.reelMatrix[0][reel][1];
    var dn_sym = server_result.result.reelMatrix[0][reel][2];
    /*
    console.log(up_sym);
    console.log(mi_sym);
    console.log(dn_sym);
    */
    if(up_sym == 9 || mi_sym == 9 || dn_sym == 9)
    {
        madnes_audio_play("symbol_Wild");
    }

    if(up_sym == 10 || mi_sym == 10 || dn_sym == 10)
    {
        madnes_audio_play("symbol_Mystery");
    }
}


// Zacatek kontroly vyher
export var result_control_pos = 0;
export function set_result_control_pos(val) {
    result_control_pos = val;
}

function stars_result_control()
{
    set_inanim(1);
    result_control_pos = 0;
    stars_result_control_part();
}

// kontrola vyhry na aktualni pozici
var wild_mask_set = new Array();
export async function stars_result_control_part()
{
    if(server_result.result.lineWins == null)
    {
        madnes_win_anim_reset();
        if(in_free_spins)
        {
            setTimeout(stars_control_freespins, 500);
        }
        else
        {
            stars_money_add_control();
        }
        return;
    }
    if(server_result.result.lineWins[result_control_pos] == null)
    {
        madnes_win_anim_reset();

        if(in_free_spins)
        {
            setTimeout(stars_control_freespins, 500);
        }
        else
        {
            stars_money_add_control();
            //madnes_end_round();
        }

        set_inwincount(false);
        return;
    }
    else
    {
        states.setState(STATES.SKIP);

        // madnes_hide_stop();
        if(madnes_win_anim_skip())
        {
            if(
                server_result.result.lineWins[result_control_pos].type == "wild" ||
                server_result.result.lineWins[result_control_pos].type == "normal"
            )
            {
                await madnes_add_win(server_result.result.lineWins[result_control_pos].win * 1); // win = win + server_result.result.lineWins[result_control_pos].win * 1;
                result_control_pos++;
                stars_result_control_part();
            }
            else
            {
                //console.log(server_result.result.lineWins[result_control_pos]);
                stars_result_control_part_proc(server_result.result.lineWins[result_control_pos])
            }
        }
        else
        {
            stars_result_control_part_proc(server_result.result.lineWins[result_control_pos])
        }
    }
}

// kontrola aktualni vyhry
var stars_result_control_part_proc_sum = new Array();
function stars_result_control_part_proc(win_set)
{
    // (Caru -> zvuk) -> zabarvit -> otocit -> prostrelit -> otocit zpet -> posunout
    set_inwincount(true);
    var linenum = 0;

    if(win_set.line !== null && typeof win_set.line !== "undefined")
    {
        linenum = win_set.line + 1;
    }

    if(linenum !== 0)
    {
        madnes_audio_pause('background');

        // madnes_win_anim_add();


        var symbol = picture_convert[win_set.symbol];
        var symbol_count = win_set.position.length;
        symbol = symbol.split("_");
        symbol = symbol[1];

        switch(symbol.toUpperCase())
        {
            case "SEVEN": symbol = "7"; break;
            case "MELON": symbol = "Meloun"; break;
            case "GRAPES": symbol = "Grapes"; break;
            case "BELL": symbol = "Bell"; break;
            case "BAR": symbol = "BAR"; break;
            case "DOLLAR": symbol = "Dolar"; break;
            case "CHERRY": symbol = "Cherry"; break;
            case "PLUM": symbol = "Plum"; break;
            case "ORANGE": symbol = "Orange"; break;
            case "WILD": symbol = "wild"; break;

            case "MYSTERY": symbol = "Mystery"; break;

            default: console.log(symbol.toUpperCase()); break;
        }

        if(symbol != "Mystery")
        {
            if(typeof stars_result_control_part_proc_sum[symbol] == "undefined")
            {
                stars_result_control_part_proc_sum[symbol] = 0;
            }
            stars_result_control_part_proc_sum[symbol] = stars_result_control_part_proc_sum[symbol] * 1 + 1;
            if(stars_result_control_part_proc_sum[symbol] > 3)
            {
                stars_result_control_part_proc_sum[symbol] = 1;
            }

            var audio_name = "win" + symbol + "_" + stars_result_control_part_proc_sum[symbol];
            madnes_audio_play(audio_name);
        }
        else
        {
            //var audio_name = "winMystery";
            var audio_name = "background_pre_mystery";
            madnes_audio_loop(audio_name);
            madnes_audio_play("bonus_Mystery_Start");
        }

        stars_result_control_part_proc_trn(win_set);

        if(win_set.type != "mystery") {

            madnes_add_win(win_set.win * 1); //win = win * 1 + win_set.win * 1;
        }
    }
    else
    {
        result_control_pos++;
        stars_result_control_part();
        if(in_free_spins)
        {
            stars_control_freespins();
        }
    }
}

// Vstup do freespinu + animace pridani spinu
var in_free_spins_tmp = false;
export function stars_add_free_spins()
{
    if(!in_free_spins)
    {
        if(freepanelpos > 0)
        {
            freepanelpos = freepanelpos * 1 - 10;
            madnes_set_pos_y("table_free-spins", he + freepanelpos);
            madnes_set_pos_y("free1", he + freepanelpos);
            madnes_set_pos_y("free2", he + freepanelpos);
            setTimeout(stars_add_free_spins, 1000 / fps);
            return;
        }

        freepanelpos = 0;

        in_free_spins = true;
        in_free_spins_pos = 0;
        madnes_set_text("free1", in_free_spins_pos.toString());
        in_free_spins_tmp = true;
    }

    if(in_free_spins_total * 1 != server_result.result.freeSpinNumber * 1)
    {

        madnes_audio_play("Btn_bet_mi");
        in_free_spins_total++;
        madnes_set_text("free2", in_free_spins_total.toString());

        setTimeout(function()
        {
            stars_add_free_spins();
        }, 120);
    }
    else
    {
        if(!in_free_spins || in_free_spins_tmp)
        {
            in_free_spins_tmp = false;
            for(var i = 0; i < 3; i++)
            {
                for(var j = 0; j < 3; j++)
                {
                    madnes_set_alpha("reels_bufer_" + i + "_S" + ( 2 - j ), 1);
                }
            }

            madnes_audio_pause('background');
            madnes_audio_loop('BACKGROUND_FS');

            setTimeout(stars_control_freespins, 1000);
        }
        else
        {
            setTimeout(stars_control_freespins, 1000);
        }
    }
}

var result_tmp; // uchovava docasne vysledek freespinu, je-li to potreba

// kontrola freespinu

function stars_control_freespins()
{
    if(server_result.result.freeSpinResults[in_free_spins_pos] == null || typeof server_result.result.freeSpinResults[in_free_spins_pos] == "undefined")
    {
        if(freepanelpos < 200)
        {
            freepanelpos = freepanelpos * 1 + 10;
            madnes_set_pos_y("table_free-spins", he + freepanelpos);
            madnes_set_pos_y("free1", he + freepanelpos);
            madnes_set_pos_y("free2", he + freepanelpos);
            setTimeout(stars_control_freespins, 1000 / fps);
            return;
        }

        freepanelpos = 200;

        in_free_spins = false;
        in_free_spins_tmp = false;
        in_free_spins_pos = 0;
        madnes_set_text("free1", in_free_spins_pos.toString());
        in_free_spins_total = 0;
        madnes_set_text("free2", in_free_spins_total.toString());

        madnes_audio_stop('BACKGROUND_FS');

        stars_money_add_control();
    }
    else
    {
        result_lock = 1;
        result_tmp = server_result.result.freeSpinResults[in_free_spins_pos].result.reelMatrix;

        server_result.result.freeSpinNumber = server_result.result.freeSpinResults[in_free_spins_pos].result.freeSpinNumber;

        setTimeout(stars_set_result_freespin, 1000);

        server_result.result.lineWins = server_result.result.freeSpinResults[in_free_spins_pos].result.lineWins;
        server_result.result.gameSpecifics = server_result.result.freeSpinResults[in_free_spins_pos].result.gameSpecifics;

        rotated = 0;

        stars_rotate_start();
        in_free_spins_pos++;
        madnes_set_text("free1", in_free_spins_pos.toString());
    }
}

// Navrat vysledku na konci freespinu
function stars_set_result_freespin()
{
    result_lock = 0;
    server_result.result.reelMatrix = result_tmp;
}

// Otoceni wild symbolu
function stars_result_control_part_proc_trn(win_set)
{
    // Caru -> zvuk -> zabarvit -> (otocit) -> prostrelit -> otocit zpet -> posunout

    for(var i = 0; i < 3; i++)
    {
        for(var j = 0; j < 3; j++)
        {
            if(
                madnes_anim_is_playing("reels_bufer_" + i + "_S" + j) ||
                madnes_anim_is_playing("reels_bufer_" + i + "_TMP" + j) ||
                madnes_anim_is_playing("reels_bufer_" + i + "_TMP2" + j)
            )
            {
                setTimeout(function()
                {
                    stars_result_control_part_proc_trn(win_set);
                }, 1000 / fps);
                return;
            }
        }
    }

    for(var i = 0; i < 3; i++)
    {
        for(var j = 0; j < 3; j++)
        {
            if(madnes_get_pos_y("reels_bufer_" + i + "_TMP" + j) > 0)
            {
                if(madnes_get_pos_y("reels_bufer_" + i + "_S" + j) < 0)
                {
                    madnes_set_pos_y("reels_bufer_" + i + "_S" + j, madnes_get_pos_y("reels_bufer_" + i + "_TMP" + j));
                    madnes_set_scale("reels_bufer_" + i + "_S" + j, 1, madnes_get_scale_y("reels_bufer_" + i + "_TMP" + j))
                }
                madnes_set_pos_y("reels_bufer_" + i + "_TMP" + j, -9999);
            }

            if(madnes_get_pos_y("reels_bufer_" + i + "_TMP2" + j) > 0)
            {
                if(madnes_get_pos_y("reels_bufer_" + i + "_S" + j) < 0)
                {
                    madnes_set_pos_y("reels_bufer_" + i + "_S" + j, madnes_get_pos_y("reels_bufer_" + i + "_TMP2" + j));
                    madnes_set_scale("reels_bufer_" + i + "_S" + j, 1, madnes_get_scale_y("reels_bufer_" + i + "_TMP2" + j))
                }
                madnes_set_pos_y("reels_bufer_" + i + "_TMP2" + j, -9999);
            }
        }
    }

    if(win_set.type == "normal")
    {
        var wilds = [];

        for(var pos in win_set.position)
        {
            var x = win_set.position[pos][0];
            var y = 2 - win_set.position[pos][1];

            var name = "reels_bufer_" + x + "_S" + y;
            var nameTmp = "reels_bufer_" + x + "_TMP" + y;
            //var nameTmp2 = "reels_bufer_" + x + "_TMP2" + y;

            var txt = madnes_get_texture(name);
            txt = txt.replace("_blur", "");

            // console.log(txt);

            madnes_set_texture(nameTmp, txt);
            for(var anim in icons[txt])
            {
                madnes_anim_add(nameTmp, anim, icons[txt][anim]);
            }
            // if(txt == "symbol_Wild")
            // {
            //     madnes_set_texture(nameTmp2, picture_convert[win_set.symbol]);
            //     for(var anim in icons[picture_convert[win_set.symbol]])
            //     {
            //         madnes_anim_add(nameTmp2, anim, icons[picture_convert[win_set.symbol]][anim]);
            //         wilds[wilds.length] = [];
            //         wilds[wilds.length - 1][0] = x;
            //         wilds[wilds.length - 1][1] = y;
            //     }
            // }

            if(madnes_get_pos_y(nameTmp) < 0 && madnes_get_pos_y(name) >= 0)
            {
                madnes_set_pos_y(
                    "reels_bufer_" + x + "_TMP" + y,
                    madnes_get_pos_y("reels_bufer_" + x + "_S" + y)
                );
                madnes_set_pos_y(
                    "reels_bufer_" + x + "_S" + y,
                    -9999
                );
                madnes_set_scale(
                    "reels_bufer_" + x + "_TMP" + y,
                    1,
                    madnes_get_scale_y("reels_bufer_" + x + "_S" + y)
                );
            }

            madnes_anim_play("reels_bufer_" + x + "_TMP" + y, "anim", 30);
        }

        // for(var pos in wilds)
        // {
        //     madnes_set_pos_y(
        //         "reels_bufer_" + wilds[pos][0] + "_TMP2" + wilds[pos][1],
        //         madnes_get_pos_y("reels_bufer_" + wilds[pos][0] + "_TMP" + wilds[pos][1])
        //     );
        //
        //     madnes_set_scale(
        //         "reels_bufer_" + wilds[pos][0] + "_TMP2" + wilds[pos][1],
        //         1,
        //         madnes_get_scale_y("reels_bufer_" + wilds[pos][0] + "_TMP" + wilds[pos][1])
        //     );
        //
        //     madnes_anim_play("reels_bufer_" + wilds[pos][0] + "_TMP2" + wilds[pos][1], "anim", 30);
        //
        //     madnes_set_alpha("reels_bufer_" + wilds[pos][0] + "_TMP2" + wilds[pos][1], 0);
        //
        //     (function (wild) {
        //
        //         madnes_alpha_to("reels_bufer_" + wild[0] + "_TMP" + wild[1], 0, 200, function() { madnes_alpha_to( "reels_bufer_" + wild[0] + '_TMP' + wild[1], 1, 200) });
        //         madnes_alpha_to("reels_bufer_" + wild[0] + "_TMP2" + wild[1], 1, 200, function() { madnes_alpha_to('reels_bufer_' + wild[0] + '_TMP2' + wild[1], 1, 200) });
        //
        //     }(wilds[pos]));
        // }

        setTimeout(function() {
            stars_result_control_part_proc_text(win_set);
        }, 1000 / fps);
    }
    else if(win_set.type == "mystery")
    {
        states.setState(STATES.BONUS);

        madnes_win_anim_reset();
        for(var pos in win_set.position)
        {
            madnes_anim_play("reels_bufer_" + win_set.position[pos][0] + "_S" + ( 2 - win_set.position[pos][1] ), "anim", 30);
        }
        setTimeout(function() {
            stars_result_control_mystery_1(win_set);
        }, 100);
    }
    else
    {
        stars_result_control_part_proc_text(win_set);
    }
}


// Prustrel vyhry
function stars_result_control_part_proc_text(win_set)
{
    for(var i = 0; i <= 2; i++)
    {
        if(!madnes_key_exist("win_text_"+i+"a"))
        {
            madnes_add_bitmap_text("win_text_"+i+"a", "wintable", cylinder_pos[i], -9999, "0", 120);
            madnes_set_img_center("win_text_"+i+"a", 0.5, 0.5);
        }
        if(!madnes_key_exist("win_text_"+i+"b"))
        {
            madnes_add_bitmap_text("win_text_"+i+"b", "wintable", cylinder_pos[i], -9999, "0", 100);
            madnes_set_img_center("win_text_"+i+"b", 0.5, 0.5);
        }
    }

    for(var i = 0; i <= 2; i++)
    {
        madnes_set_text("win_text_"+i+"a", madnes_money_to_coin(win_set.win).toString());
        madnes_set_alpha("win_text_"+i+"a", 1);

        setTimeout(madnes_alpha_to.bind(this, "win_text_"+i+"a", 0, 200), 400);

        if(win_set.multiplier > 1)
        {
            madnes_set_alpha("win_text_"+i+"b", 1);
            setTimeout(madnes_alpha_to.bind(this, "win_text_"+i+"b", 0, 200), 400);
            madnes_set_text("win_text_"+i+"b", "X" + win_set.multiplier.toString());
        }
        else
        {
            madnes_set_text("win_text_"+i+"b", "");
        }
    }

    madnes_set_pos_y("win_text_0a", 140 + win_set.position[0][1] * ico_he );
    madnes_move_to("win_text_0a", madnes_get_pos_x("win_text_0a"), 100 + win_set.position[0][1] * ico_he, 600);
    madnes_set_pos_y("win_text_0b", 200 + win_set.position[0][1] * ico_he);
    madnes_move_to("win_text_0b", madnes_get_pos_x("win_text_0b"), 160 + win_set.position[0][1] * ico_he, 600);

    madnes_set_pos_y("win_text_1a", 140 + win_set.position[1][1] * ico_he);
    madnes_move_to("win_text_1a", madnes_get_pos_x("win_text_1a"), 100 + win_set.position[1][1] * ico_he, 600);
    madnes_set_pos_y("win_text_1b", 200 + win_set.position[1][1] * ico_he);
    madnes_move_to("win_text_1b", madnes_get_pos_x("win_text_1b"), 160 + win_set.position[1][1] * ico_he, 600);

    madnes_set_pos_y("win_text_2a", 140 + win_set.position[2][1] * ico_he);
    madnes_move_to("win_text_2a", madnes_get_pos_x("win_text_2a"), 100 + win_set.position[2][1] * ico_he, 600);
    madnes_set_pos_y("win_text_2b", 200 + win_set.position[2][1] * ico_he);
    madnes_move_to("win_text_2b", madnes_get_pos_x("win_text_2b"), 160 + win_set.position[2][1] * ico_he, 600);
    /*
    setTimeout(function() {
        stars_result_control_part_proc_text_back(win_set);
    }, 1000 / fps);
    */
    setTimeout(function() {
        stars_result_control_part_proc_trn_back(win_set);
    }, 600);
}

// Nacasovani skryti prustrelu
/*
function stars_result_control_part_proc_text_back(win_set)
{
	var end = true;
	for(var i = 0; i <= 2; i++)
	{
		madnes_set_pos_y("win_text_"+i+"a", madnes_get_pos_y("win_text_"+i+"a") * 1 - 2);
		madnes_set_pos_y("win_text_"+i+"b", madnes_get_pos_y("win_text_"+i+"b") * 1 - 2);

		var alp = madnes_get_alpha("win_text_"+i+"a");
		alp = alp * 1 - 0.05;
		if(alp < 0)
		{
			alp = 0;
		}
		else
		{
			end = false;
		}
		madnes_set_alpha("win_text_"+i+"a", alp)

		var alp = madnes_get_alpha("win_text_"+i+"b");
		alp = alp * 1 - 0.05;
		if(alp < 0)
		{
			alp = 0;
		}
		else
		{
			end = false;
		}
		madnes_set_alpha("win_text_"+i+"b", alp)
	}

	if(end)
	{
		stars_result_control_part_proc_trn_back(win_set);
	}
	else
	{
		setTimeout(function() {
			stars_result_control_part_proc_text_back(win_set);
		}, 1000 / fps);
	}
}
*/

// Navrat symbolu
function stars_result_control_part_proc_trn_back(win_set)
{
    // Caru -> zvuk -> zabarvit -> otocit -> prostrelit -> (otocit zpet) -> posunout
    stars_result_control_part_proc_nxt(win_set);
}

// Konec animace -> prejit na kontrolu dalsi (pouze nacasovani)
function stars_result_control_part_proc_nxt(win_set)
{
    // Caru -> zvuk -> zabarvit -> otocit -> prostrelit -> otocit zpet -> (posunout)

    for(var i = 0; i < 3; i++)
    {
        for(var j = 0; j < 3; j++)
        {
            if(
                madnes_anim_is_playing("reels_bufer_" + i + "_S" + j) ||
                madnes_anim_is_playing("reels_bufer_" + i + "_TMP" + j) ||
                madnes_anim_is_playing("reels_bufer_" + i + "_TMP2" + j)
            )
            {
                setTimeout(function()
                {
                    stars_result_control_part_proc_nxt(win_set);
                }, 1000 / fps);
                return;
            }
        }
    }

    result_control_pos++;
    stars_result_control_part();
}


export var win_anim_played = false;

export function set_win_anim_played(val) {
    win_anim_played = val;
}

// Zacatek kontroly pridavani penez
function stars_money_add_control()
{
    // madnes_show_btns();

    set_inwincount(false);

    if(!win_anim_played && win * 1 > 0)

    {
        stars_money_add_win( madnes_money_to_coin( win ) );
        //madnes_audio_loop('remittance_A');
    }
    else
    {
        setTimeout(madnes_audio_stop.bind(null, 'remittance_A'), 200);

        madnes_audio_loop('background');
        madnes_end_round();
        //
        // madnes_end_round(true, {}, {}, function () {
        //
        //     end_result_control();
        //
        // });
    }
}

export function is_in_autostart()
{
    return !!autostart;
    //return autostart * 1 > 0 || autostart == "∞";
}

export function stars_end_round_recalced()
{
    set_inwincount(false);
    set_inmoneyadd(0); //inmoneyadd = 0;
    set_inanim(0);
    win_anim_played = false;

    // madnes_on_end_round_recount(win);
    // madnes_on_round_end();
    // madnes_recount_bet();
    //
    // autospin_force_enabled = false;
    // if(is_in_autostart() || autospin_force)
    // {
    //     autospin_force = false;
    //     madnes_rotate_start();
    // }
}

var fromsaloon = 0; // Prichazime ze saloonu? nebude vybuch
var boom_digits = 0; // pocet cislic pri vybuchu
var boom_ready = 0;  // je vybuch dokoncen / pripraven pro vypisovani cislic
var boom_sum = 0;   // aktualni suma na papire vybuchu

var moneyadd_pos = 0;
var moneyadd_dir = 0;
var money_add_win_speed = 18;

function stars_money_add_win(max)
{
    if(inmoneyadd == 0 && inbigwin == 0 && fromsaloon == 0 && from_bonus == 0)
    {
        if(max * 1 > bet * 1 * big_win)
        {
            states.setState(STATES.BONUS_WIN);
            // madnes_hide_btns();
            stars_money_add_big_win(max);
            return;
        }

        set_inmoneyadd(1);
    }

    from_bonus = 0;

    set_inanim(1);

    win_anim_played = true;

    madnes_show_money(max, function() {

        stars_money_add_control();
        set_inmoneyadd(0);
        set_inanim(0);
    });

    set_inbigwin(0);
    fromsaloon = 0;
    //setTimeout(stars_money_add_control, 1000);
}

function stars_money_add_big_win(max)
{
    madnes_start_coin();

    madnes_audio_play("win");

    set_inbigwin(1);

    setTimeout(stars_money_add_big_win_anim.bind(null, max), 1000 / 60);
}










// stars_money_add_big_win(100)

var render_stars_money_add_big_win_anim;

var stars_money_add_big_win_anim_pos = 0;
var stars_money_add_big_win_anim_starttime = 0;
var stars_money_add_big_win_anim_starttime0 = 0;
var stars_money_add_big_win_anim_money = 0;
var stars_money_add_big_win_anim_money_pos = 0;
var stars_money_add_big_win_anim_type = 0;
function stars_money_add_big_win_anim(max)
{
    // add big win

    var time = madnes_get_currtime();

    if(stars_money_add_big_win_anim_pos == 0)
    {
        stars_money_add_big_win_anim_pos = 1;
        stars_money_add_big_win_anim_starttime = madnes_get_currtime();
        stars_money_add_big_win_anim_starttime0 = stars_money_add_big_win_anim_starttime;
        stars_money_add_big_win_anim_money = 0;
        stars_money_add_big_win_anim_type = 0;

        madnes_set_pos("bw_bg", wi / 2, he / 2);
        madnes_set_alpha("bw_bg", 0);
        madnes_alpha_to("bw_bg", 1, 500);

        madnes_set_pos("bw_shine1", wi / 2 - 60, he / 2 - 40);
        madnes_set_alpha("bw_shine1", 0);
        madnes_alpha_to("bw_shine1", 1, 500);
        madnes_set_scale("bw_shine1", 1.1, 1.1);

        madnes_set_pos("bw_shine2", wi / 2 + 40, he / 2 + 20);
        madnes_set_alpha("bw_shine2", 0);
        madnes_alpha_to("bw_shine2", 1, 500);
        madnes_set_scale("bw_shine2", 0.9, 0.9);


        madnes_set_pos("bw_table", wi / 2, he / 2);
        madnes_set_alpha("bw_table", 0);
        madnes_alpha_to("bw_table", 1, 500);

        madnes_set_pos("bw_text", wi / 2, he / 2 + 40);
        madnes_set_alpha("bw_text", 0);
        madnes_alpha_to("bw_text", 1, 500);

        madnes_set_pos("bw_big", wi / 2, he / 2 - 120);
        madnes_set_alpha("bw_big", 0);
        madnes_alpha_to("bw_big", 1, 500);

        madnes_set_pos("bw_mega", wi / 2, he / 2 - 120);
        madnes_set_alpha("bw_mega", 0);

        madnes_set_pos("bw_super", wi / 2, he / 2 - 120);
        madnes_set_alpha("bw_super", 0);



        madnes_set_pos("bw_stroke", wi / 2, he / 2);
        madnes_set_alpha("bw_stroke", 0);

        //madnes_audio_loop('JPT_MONEY');

        render_stars_money_add_big_win_anim = function() {
            stars_money_add_big_win_anim(max);
        };

        madnes_add_to_render(render_stars_money_add_big_win_anim);
    }
    else if(stars_money_add_big_win_anim_pos == 1)
    {
        var difftime = time - stars_money_add_big_win_anim_starttime;

        //var tmp = Math.round( max * ( ( difftime - ( ( stars_money_add_big_win_anim_type + 1 ) * 500 ) ) / 4000) );
        var tmp = Math.round( max * ( ( difftime - ( ( stars_money_add_big_win_anim_type + 1 ) * 0 ) ) / 4000) );

        if(tmp > stars_money_add_big_win_anim_money)
        {
            stars_money_add_big_win_anim_money = tmp;
            if(stars_money_add_big_win_anim_money_pos++ % 4 == 0)
            {
                madnes_audio_play("remittance_A");
            }
            madnes_set_text("bw_text", stars_money_add_big_win_anim_money);
        }

        if(stars_money_add_big_win_anim_money > max)
        {
            stars_money_add_big_win_anim_money = max;
            stars_money_add_big_win_anim_pos = 2;
            stars_money_add_big_win_anim_starttime = madnes_get_currtime();
            madnes_set_text("bw_text", stars_money_add_big_win_anim_money);
            madnes_audio_play("remittance_B");
            madnes_stop_coin();
        }

        if(stars_money_add_big_win_anim_type == 0 && mega_win * bet < stars_money_add_big_win_anim_money)
        {
            stars_money_add_big_win_anim_type = 1;
            madnes_alpha_to("bw_big", 0, 500);
            madnes_alpha_to("bw_mega", 1, 500);
        }

        if(stars_money_add_big_win_anim_type == 1 && super_win * bet < stars_money_add_big_win_anim_money)
        {
            stars_money_add_big_win_anim_type = 2;
            madnes_alpha_to("bw_mega", 0, 500);
            madnes_alpha_to("bw_super", 1, 500);
        }

        madnes_set_angle("bw_shine1", ( ( difftime / 10 ) % 360 ) );
        madnes_set_angle("bw_shine2", 360 - ( ( difftime / 16 ) % 360 ) );
    }
    else if(stars_money_add_big_win_anim_pos == 2)
    {
        var difftime = time - stars_money_add_big_win_anim_starttime;
        var difftime0 = time - stars_money_add_big_win_anim_starttime0;

        madnes_set_angle("bw_shine1", ( ( difftime0 / 10 ) % 360 ) );
        madnes_set_angle("bw_shine2", 360 - ( ( difftime0 / 16 ) % 360 ) );

        if(difftime > 2500)
        {
            var time_alp = 300;

            madnes_alpha_to("bw_bg", 0, time_alp);
            madnes_alpha_to("bw_shine1", 0, time_alp);
            madnes_alpha_to("bw_shine2", 0, time_alp);
            madnes_alpha_to("bw_table", 0, time_alp);
            madnes_alpha_to("bw_text", 0, time_alp);
            madnes_alpha_to("bw_big", 0, time_alp);
            madnes_alpha_to("bw_mega", 0, time_alp);
            madnes_alpha_to("bw_super", 0, time_alp);
            madnes_alpha_to("bw_stroke", 0, time_alp);

            stars_money_add_big_win_anim_pos = 3;
            stars_money_add_big_win_anim_starttime = madnes_get_currtime();
        }
    }
    else if(stars_money_add_big_win_anim_pos == 3)
    {
        var difftime = time - stars_money_add_big_win_anim_starttime;
        if(difftime > 300)
        {
            stars_money_add_big_win_anim_pos = 0;
            madnes_rem_from_render(render_stars_money_add_big_win_anim);

            win_anim_played = true;
            set_inmoneyadd(0);
            set_inbigwin(0);

            setTimeout(stars_money_add_control, 400);

            madnes_audio_stop("win");

            //setTimeout(stars_money_add_win.bind(null, max), 100);

            //madnes_audio_stop('JPT_MONEY');

        }
    }
}

export var from_bonus = 0;

export function set_from_bonus(val) {
    from_bonus = val;
}


// Konec kontroly penez

/**
 *
 * @param {Object=} params
 * @param {Function=} callback
 */
function stars_end_round(params, callback)
{
    params = params ? params : {};
    madnes_end_round(params['ended'], params['fs_win'], params['fs_order'], params['fs_count'], callback);
}